import React from 'react';
import { ExecutiveProvider } from 'contexts/executive.context';
import ExecutiveContent from './content';

const ExecutiveLayout = () => {
  return (
    <ExecutiveProvider>
      <ExecutiveContent />
    </ExecutiveProvider>
  );
};

export default ExecutiveLayout;
